import axios from 'axios';
import AuthenticationService from "../Authentication/Service";
import SessionService from '../SessionService';

const ENDPOINT_API_URL = ''; //import.meta.env.VITE_ENDPOINT_API_URL || '';



class EndpointService {



    async fetch(url, method, data, options, authenticationService) {

        url = `${ENDPOINT_API_URL}${url}`;

        try {
            let authorization = await (authenticationService || AuthenticationService).getAuthorizationToken();
        
            let headers = {}
            if(authorization) {
                headers['Authorization'] = `Bearer ${authorization}`;
            }
    
            let response = await axios({
                url: url,
                method,
                data,
                headers: {
                    ...headers,
                    ...options?.headers,
                    'X-Tab-Id': SessionService.getClientId()
                },
                ...options
            });

            return response.data;
        } catch (e) {
            console.error(e);
            if(e?.response?.status === 401) {
                // throw new Error(e);
                console.log("401 ", e)
                return { error: e.response.data.error };
            } else {
                throw new Error(e);
            }
        }
    
    }

    async get(url, options, authenticationService) {
        return await this.fetch(url, 'GET', undefined, options, authenticationService);
    }

    async post(url, data, options, authenticationService) {
        return await this.fetch(url, 'POST', data, options, authenticationService);
    }

    async put(url, data, options, authenticationService) {
        return await this.fetch(url, 'PUT', data, options, authenticationService);
    }

    async delete(url, options, authenticationService) {
        return await this.fetch(url, 'DELETE', undefined, options, authenticationService);
    }


}

export default new EndpointService();